import instance from '@/service/instance';
import { AxiosPromise } from 'axios';

import { SessionExercise } from '@/helpers/types';
import { CreateSessionExerciseDto } from '@/dto/session-exercise/create-session-exercise.dto';

const resource: string = '/session-exercise';

export default {
  /**
   * Fetch all session exercises from API
   * @param {string} token
   * @return {AxiosPromise<SessionExercise[]>} exercises
   * */
  list(token: string): AxiosPromise<SessionExercise[]> {
    return instance.get(`${resource}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  /**
   * Create session exercise
   * @param {string} token
   * @param {CreateSessionExerciseDto} payload
   * @return {AxiosPromise<SessionExercise>} exercise
   * */
  create(token: string, payload: CreateSessionExerciseDto): AxiosPromise<SessionExercise> {
    return instance.post(`${resource}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  /**
   * Update session exercise
   * @param {string} token
   * @param {number} id
   * @param {Object} payload
   * @return {AxiosPromise<SessionExercise>>} exercise
   * */
  updateExercise(token: string, id: number, payload: any): AxiosPromise<SessionExercise> {
    return instance.patch(`${resource}/${id}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
  /**
   * Delete session exercise
   * @param {string} token
   * @param {number} id
   * @return {AxiosPromise<void>}
   * */
  deleteExercise(token: string, id: number): AxiosPromise<void> {
    return instance.delete(`${resource}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
};
